import React from 'react';
import { Fields } from 'redux-form';

import { ContentSet, FlexRow } from 'components/Shared/Scaffolding';
import { InputField } from 'components/Shared/Forms';
import GooglePlacesSearch from 'components/Shared/GooglePlacesSearch';
import { LinkButton } from 'components/Shared/Buttons';
import { SCAFFOLDING } from 'theme';
import { parseDecimalInput, hasValue } from 'utils/validation';

const MODES = {
    LATLNG: 'latlng',
    SEARCH: 'search',
};

class LocationInput extends React.Component {
    state = {
        mode: this.props.defaultMode || MODES.LATLNG,
        address: '',
    };

    renderFields = ({ lat, lng, place, showSearch }) => {
        // Use the same place props but with our custom onChange handler
        const placeProps = {
            ...place,
            input: {
                ...place.input,
                onChange: (value) => {
                    lat.input.onChange(value.lat);
                    lng.input.onChange(value.lng);
                    this.handleToggle();
                },
            },
        };

        return (
            <FlexRow>
                {!showSearch && (
                    <InputField
                        {...lat}
                        width="100%"
                        labelInline
                        required
                        type="number"
                        label="Latitude"
                        step="0.000001"
                    />
                )}
                {!showSearch && (
                    <InputField
                        {...lng}
                        width="100%"
                        labelInline
                        required
                        type="number"
                        label="Longitude"
                        step="0.000001"
                    />
                )}
                {showSearch && <GooglePlacesSearch {...placeProps} />}
            </FlexRow>
        );
    };

    parseFields = (value, name) => {
        if (name.includes('lat')) {
            return this.inRange(value, -90, 90);
        } else if (name.includes('lng')) {
            return this.inRange(value, -180, 180);
        }
        return value;
    };

    inRange = (value, min, max) => {
        const lat = parseDecimalInput(value);
        if (!hasValue(lat)) return value;
        return Math.min(Math.max(lat, min), max);
    };

    handleToggle = (e) => {
        if (e) e.preventDefault();
        this.setState((prevState) => ({
            mode: prevState.mode === MODES.LATLNG ? MODES.SEARCH : MODES.LATLNG,
        }));
    };

    render() {
        return (
            <ContentSet spacing={SCAFFOLDING.GUTTER_FACTOR(0.25)}>
                <Fields
                    names={['lat', 'lng', 'place']}
                    component={this.renderFields}
                    parse={this.parseFields}
                    showSearch={this.state.mode === MODES.SEARCH}
                />
                <LinkButton onClick={this.handleToggle}>
                    {this.state.mode === MODES.LATLNG
                        ? 'Or search for a location'
                        : 'Or enter the latitude and longitude'}
                </LinkButton>
            </ContentSet>
        );
    }
}

export default LocationInput;
